import React, { useState, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { toast } from 'react-toastify';

import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Icon from '@components/Icon';
import Loader from '@components/Loader';
import { Button } from '@mui/material';

import logoUrl from '@images/logo.svg';
import imgUrl from '@images/loginImg.svg';

import { hasToken, setToken } from '@helpers/token';

import AuthApi from '@api/auth.api';
import * as commonS from '@styles/common';
import stores from '@stores';
import store from './store';

import * as S from './styles';

const LoginScreen = () => {
  const { handleChange, isLoading, user } = store;
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState({
    username: false,
    password: false
  });
  const { sessionStore } = stores;

  const handleSubmit = async () => {
    if (!user.username || !user.password) {
      setError({
        username: !(user.username),
        password: !(user.password)
      });
    } else {
      setError({
        username: false,
        password: false
      });
      await AuthApi.login(user).then((e: any) => (
        e.message ?
          toast.error(e.message) : setToken(e)
      ));

      if (hasToken()) {
        await sessionStore.getCurrentUser();
        navigate('/projekte');
      }
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <commonS.Body>
      <commonS.Container>
        <S.Header>
          <S.Logo>
            <img src={logoUrl} alt='logo' />
          </S.Logo>
        </S.Header>

        <S.Row>
          <S.FormWrap>
            <S.Title>Willkommen zu: <br /> Klasseneinteilung einfach gemacht</S.Title>

            <S.Form
              component="form"
              autoComplete="off"
            >

              <S.FormItem>
                <InputLabel htmlFor='username' shrink={false}>Benutzername</InputLabel>
                <TextField
                  id="username"
                  name="username"
                  error={error.username}
                  helperText={error.username ? 'Benutzername can not be blank!' : ''}
                  onChange={handleChange}
                  variant="outlined"
                />
              </S.FormItem>

              <S.FormItem>
                <S.PasswordWrap>
                  <InputLabel htmlFor='password' shrink={false}>Passwort</InputLabel>
                  <span className='show-password' onClick={handleClickShowPassword}>
                    <Icon icon={showPassword ? 'eye-crossed' : 'eye'} size={18} /> Ausblenden
                  </span>
                </S.PasswordWrap>
                <TextField
                  id="password"
                  name="password"
                  error={error.password}
                  helperText={error.password ? 'Password can not be blank!' : ''}
                  onChange={handleChange}
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  autoComplete="off"
                />
              </S.FormItem>

              <Button fullWidth variant='contained' onClick={handleSubmit} size='large'>Einloggen</Button>
            </S.Form>
          </S.FormWrap>

          <S.ImgWrap>
            <img src={imgUrl} alt='img' />
          </S.ImgWrap>
        </S.Row>

        {isLoading && <Loader filled={false} />}
      </commonS.Container>
    </commonS.Body>
  );
};

export default observer(LoginScreen);
